import { Moment } from "moment";
import { useState } from "react";
import { optionsPOST, url_interna } from "../../../config/constants";

import { useLocalStorage } from "hooks/otros/useLocalStorage";
import { useVerifyResponse } from "hooks/otros/useVerifyReponse";
import moment from "moment";
import { TableColumnsType } from "antd";

import { useLayout } from "hooks/otros/useLayout";

import { useSearchTableNew } from "hooks/otros/useSearchTableNew";
import { useExport } from "hooks/otros/useExport";

type CargosPendientes = {
  key: React.Key;
  Cod_Bodega: number;
  Bodega: number;
  Cod_Producto: number;
  Cod_MIA: number;
  Cod_Barra: string;
  Producto: string;
  Cantidad: number;
  Unidad_Medida: number;
  CostoFraccion: number;
};

const breadcrumbs = [
  { Label: "Inventarios", Url: "/inventario" },
  { Label: "Logistica", Url: "/inventarios/logistica" },
  { Label: "Cargos Pendientes logistica inversa" },
];
//const breadcrumbs = [{ Label: "Inventarios", Url: "/inventario" }, { Label: "Productividad" }];

const openKeys = [breadcrumbs[0].Label, breadcrumbs[0].Label + "/" + breadcrumbs[1].Label];
export function useCargosPendientesLogisticaInversa() {
  useLayout(breadcrumbs, openKeys, breadcrumbs[1].Label + "/" + breadcrumbs[2].Label);
  const [datos, setDatos] = useState<CargosPendientes[]>([]);
  const [searchText] = useState("");
  const [filteredData, setFilteredData] = useState<CargosPendientes[]>([]);
  const { getColumnSearchPropsNew } = useSearchTableNew<CargosPendientes>();
  const { exportToExcel } = useExport();
  let { optionsPost } = useLocalStorage();
  const { isError } = useVerifyResponse();
  const [[fechaInicio, fechaFin], setFechas] = useState<[Moment | null, Moment | null]>([null, null]);
  const [dataEstado, setDataEstado] = useState<boolean>(false);

  const [estadoBotones, setDataBoton] = useState<boolean>(false);

  /*const formateaCantidad = (cantidad: number) => {
    const totalCostoFormateado = (cantidad / 1).toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return totalCostoFormateado;
  };
*/

  const columns: TableColumnsType<CargosPendientes> = [
    {
      title: "Cod_B",
      dataIndex: "Cod_Bodega",
      key: "Cod_Bodega",
      className: "letraPequenaVisor2",
      width: "50px",
    },
    {
      title: "Bodega",
      dataIndex: "Bodega",
      key: "Bodega",
      width: "150px",
      className: "letraPequenaVisor2",
      //...getColumnSearchPropsNew("Bodega"),
      filters: [...new Set(datos.map(({ Bodega }) => Bodega))].map((Bodega) => ({
        text: Bodega,
        value: Bodega,
      })),
      filterSearch: true,
      onFilter: (value, record) => value === record.Bodega,
    },
    {
      title: "Cod producto",
      dataIndex: "Cod_Producto",
      key: "Cod_Producto",
      className: "letraPequenaVisor2",
      width: "100px",
    },
    {
      title: "Cod MIA",
      dataIndex: "Cod_MIA",
      key: "Cod_MIA",
      width: "100px",
      className: "letraPequenaVisor2",
    },
    {
      title: "Cod Barra",
      dataIndex: "Cod_Barra",
      key: "Cod_Barra",
      width: "150px",
      className: "letraPequenaVisor2",
    },
    {
      title: "Producto",
      dataIndex: "Producto",
      key: "Producto",
      width: "300px",
      className: "letraPequenaVisor2",
      ...getColumnSearchPropsNew("Producto"),
    },
    {
      title: "Costo Fraccion",
      dataIndex: "CostoFraccion",
      key: "CostoFraccion",
      className: "letraPequenaVisor2",
      align: "right",
    },
    {
      title: "Cantidad",
      dataIndex: "Cantidad",
      key: "Cantidad",
      className: "letraPequenaVisor2",
      align: "right",
      sorter: (a, b) => a.Cantidad - b.Cantidad,
      sortDirections: ["descend", "ascend"],
      /*render: (_, record) => (
        <span style={{ color: record.Cantidad === 0 ? "lightgray" : "black" }}>
          {formateaCantidad(record.Cantidad)}
        </span>
        // <span style={{ color: record.total === 0 ? "lightgray" : "black" }}>{record.total}</span>
      ),*/
    },
  ];
  const disabledDate = (current: moment.Moment) => {
    if (!fechaInicio) {
      return current && current >= moment().endOf("day"); // Mientras no haya fecha inicial, deshabilita fechas futuras
    }
    const minDate = fechaInicio.clone().startOf("day");
    const maxDate = fechaInicio.clone().add(6, "months").add(1, "days").endOf("day");
    const today = moment().startOf("day"); // Fecha actual (final del día)

    return current && (current < minDate || current > maxDate || current > today);
  };

  const getCargosTransferencias = async (fechaInicio: Moment, fechaFin: Moment) => {
    setDataEstado(false);
    setDataBoton(true);
    try {
      const res = await fetch(
        url_interna + "api/inventarios/cargos_pendientes_logistica_inversa",
        optionsPOST(
          JSON.stringify({
            fechaInicio: fechaInicio!.format("DD/MM/YYYY"),
            fechaFin: fechaFin!.format("DD/MM/YYYY"),
          }),
          {
            "api-token": "apitoken",
          }
        )
      );
      if (isError(res)) throw new Error();
      const respuesta = await res.json();

      if (respuesta.msg !== "err") {
        const respuestas: CargosPendientes[] = respuesta.data;
        setDataEstado(true);
        setDataBoton(false);
        setDatos(
          respuestas.map(
            ({
              Cod_Bodega,
              Bodega,
              Cod_Producto,
              Cod_MIA,
              Cod_Barra,
              Producto,
              Cantidad,
              Unidad_Medida,
              CostoFraccion,
              key,
            }) => ({
              Cod_Bodega,
              Bodega,
              Cod_Producto,
              Cod_MIA,
              Cod_Barra,
              Producto,
              Cantidad,
              Unidad_Medida,
              CostoFraccion,
              key,
            })
          )
        );
        setFilteredData(respuesta.data);
      } else {
        setDataEstado(false);
        setDataBoton(false);
        return { msg: "Ocurrio un error", status: false };
      }
    } catch (e) {
      setDataEstado(false);
      setDataBoton(false);
      return { msg: "no_conexion", status: false };
    }
  };
  /*  const calcularTotales = () => {
    let total = 0.0;

    filteredData.forEach((item) => {
      total += item.Total;
    });
    total = parseFloat(total.toFixed(2));
    let valor = formateaCantidad(total);
    return { valor };
  };*/
  const handleChangeButton = () => {
    try {
      if (fechaInicio && fechaFin) {
        getCargosTransferencias(fechaInicio, fechaFin);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleClickDownloadData = () => {
    const datosParaExportar = filteredData.map(({ key, ...resto }) => resto);
    exportToExcel(datosParaExportar, "Cargos pendientes logistica inversa");
  };

  return {
    columns,
    datos,
    handleChangeButton,
    estadoBotones,
    disabledDate,
    dataEstado,
    getCargosTransferencias,
    searchText,
    optionsPost,
    fechaInicio,
    fechaFin,
    setFechas,
    handleClickDownloadData,
    // calcularTotales,
  };
}
